/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Manual_DescInputs */

const en_simple_door_manual_desc = /** @type {(inputs: Simple_Door_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You or your technical team build it, using ready-to-paste instructions from Bystep.`)
};

const id_simple_door_manual_desc = /** @type {(inputs: Simple_Door_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu atau tim teknismu yang mengerjakan, memakai petunjuk siap tempel dari Bystep.`)
};

/**
* | output |
* | --- |
* | "You or your technical team build it, using ready-to-paste instructions from Bystep." |
*
* @param {Simple_Door_Manual_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_manual_desc = /** @type {((inputs?: Simple_Door_Manual_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Manual_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_manual_desc(inputs)
	return en_simple_door_manual_desc(inputs)
});